import { Effect, Layer } from "effect";
import { BrowserHttpClient } from "@effect/platform-browser";
import { withWorkerstationBase } from "@workerstation/shared";
import { resourceUnavailable } from "@workerstation/shared/errors/resource";
import { QueueApi } from "../../api/queues/service.ts";
import { makeQueueApi } from "../../api/queues/live.ts";
import { QueueBrowserIo } from "./service.ts";
export const QueueBrowserIoLive = Layer.succeed(QueueBrowserIo, {
  prompt: Effect.try({ try: () => window.prompt("Queue message (JSON or text)", "{}"), catch: () => resourceUnavailable() }),
  confirmPurge: Effect.fn("Frontend.Queue.confirmPurge")((queueName: string) => Effect.try({ try: () => window.confirm(`Delete every stored message in ${queueName}?`), catch: () => resourceUnavailable() }))
});
const QueueBrowserApiLive = Layer.effect(QueueApi, Effect.gen(function* () {
  const base = yield* Effect.sync(() => (typeof window === "undefined" ? "https://workerstation.invalid" : window.location.origin) + withWorkerstationBase(""));
  return yield* makeQueueApi(base);
})).pipe(Layer.provide(BrowserHttpClient.layerFetch));
export const QueueBrowserPortsLive = Layer.merge(QueueBrowserApiLive, QueueBrowserIoLive);
